import base from 'kiosk/profile';

Vue.component('spark-kiosk-profile', {
    mixins: [base]
});
